import { createSlice } from "@reduxjs/toolkit"
import httpClient from "./httpClient"
import MAIL_TYPES from "../pages/admin/mailer/mailTypes"
import MAIL_PROTOCOLES from "../pages/admin/mailer/mailProtocoles"
import AUTH_METHOD from "../pages/admin/mailer/authMethod"
import LOGS_SENT_MAIL from "../pages/admin/mailer/logsSentMailValues"
import { asBoolean } from "../commons/utils"

const initialState = {
  accountSmtp: {},
  smtpTest: {},
  dialogIsShowing: false,
  typeServer: MAIL_TYPES.OUTLOOK,
  activeInput: true,
  protocol: MAIL_PROTOCOLES.TLS_PROTOCOLE,
  methodAuth: AUTH_METHOD.BASIC,
  isBasicAuth: true,
  isAccountService: false,
  isOAuth2: false,
  isRefreshToken: false,
  pool: false,
  logs: LOGS_SENT_MAIL.LOGS_ANY,
  listProperty: [],
  propertiesChanged: false,
  property: "",
  propertyChanged: false,
  valeurChanged: false,
  valeur: "",
  properties: [],
  indexInput: 0,
  formIsReseted: false,
  inValidProperty: false,
  inValidValue: false,
  to: ""
}
const smtpAccountSlice = createSlice({
  name: "smtpForm",
  initialState,
  reducers: {
    setTo: (state, { payload }) => ({
      ...state,
      to: payload
    }),
    setAccountSmtp: (state, { payload }) => ({
      ...state,
      accountSmtp: payload
    }),
    setSmtpTest: (state, { payload }) => ({
      ...state,
      smtpTest: payload
    }),
    setDialogIsShowing: (state, { payload }) => ({
      ...state,
      dialogIsShowing: asBoolean(payload)
    }),
    setTypeServer: (state, { payload }) => ({
      ...state,
      typeServer: payload
    }),
    setActiveInput: (state, { payload }) => ({
      ...state,
      activeInput: asBoolean(payload)
    }),
    setProtocol: (state, { payload }) => ({
      ...state,
      protocol: payload
    }),
    setMethodAuth: (state, { payload }) => ({
      ...state,
      methodAuth: payload
    }),
    setIsBasicAuth: (state, { payload }) => ({
      ...state,
      isBasicAuth: asBoolean(payload)
    }),
    setIsAccountService: (state, { payload }) => ({
      ...state,
      isAccountService: asBoolean(payload)
    }),
    setIsOAuth2: (state, { payload }) => ({
      ...state,
      isOAuth2: asBoolean(payload)
    }),
    setIsRefreshToken: (state, { payload }) => ({
      ...state,
      isRefreshToken: asBoolean(payload)
    }),
    setPool: (state, { payload }) => ({
      ...state,
      pool: asBoolean(payload)
    }),
    setLogs: (state, { payload }) => ({
      ...state,
      logs: payload
    }),
    setListProperty: (state, { payload }) => ({
      ...state,
      listProperty: payload
    }),
    setPropertiesChanged: (state, { payload }) => ({
      ...state,
      propertiesChanged: asBoolean(payload)
    }),
    setProperty: (state, { payload }) => ({
      ...state,
      property: payload
    }),
    setPropertyChanged: (state, { payload }) => ({
      ...state,
      propertyChanged: asBoolean(payload)
    }),
    setValeurChanged: (state, { payload }) => ({
      ...state,
      valeurChanged: asBoolean(payload)
    }),
    setValeur: (state, { payload }) => ({
      ...state,
      valeur: payload
    }),
    setProperties: (state, { payload }) => ({
      ...state,
      properties: payload
    }),
    setIndex: (state, { payload }) => ({
      ...state,
      indexInput: payload
    }),
    setFormIsReseted: (state, { payload }) => ({
      ...state,
      formIsReseted: asBoolean(payload)
    }),
    setInValidProperty: (state, { payload }) => ({
      ...state,
      inValidProperty: asBoolean(payload)
    }),
    setInValidValue: (state, { payload }) => ({
      ...state,
      inValidValue: asBoolean(payload)
    })
  }
})
function fetchAccount() {
  return (dispatch) =>
    httpClient.get("/api/compteMailer").then(({ data }) => {
      dispatch(smtpAccountSlice.actions.setAccountSmtp(data))
    })
}
function fetchAccountDetails() {
  return (dispatch) =>
    httpClient.get("/api/compteMailerDetails").then(({ data }) => {
      dispatch(smtpAccountSlice.actions.setAccountSmtp(data))
    })
}
function saveOrUpdate(smtp) {
  return (dispatch) =>
    httpClient.post("/api/compteMailer", smtp).then(() => {
      dispatch(fetchAccount())
    })
}
function testSendMail(smtp) {
  return httpClient.post("/api/compteMailer/testSendMail", smtp)
}
function saveMailSenderTest(data) {
  return (dispatch) => dispatch(smtpAccountSlice.actions.setTo(data))
}
export default {
  initialState,
  actions: {
    ...smtpAccountSlice.actions,
    fetchAccount,
    fetchAccountDetails,
    saveOrUpdate,
    testSendMail,
    saveMailSenderTest
  },
  reducer: smtpAccountSlice.reducer
}
